import AboutUsImage from "../../../assets/images/Mission.jpg";
import { ReactComponent as Dash } from "../../../assets/icons/BulletPoint.svg";

const OurMission = () => {
  return (
    <div className="about-section ">
      <div className="about-section-content">
        <div className="nav-bold secondary">Mission and Values</div>
        <h2 className="primary">
          Stronger Plans,
          <span style={{ fontStyle: "italic" }}> Stronger Future</span>
        </h2>
        <div className="row">
          <div >
            <img src={AboutUsImage} alt="About Us" className="image" />
          </div>
          <div className="column align-left">
            <div className="content primary row-gap-20" >
              <Dash className="bullet-icon" />
              Build financial plans that hold up under pressure
            </div>
            <div className="content primary row-gap-20">
              <Dash className="bullet-icon" />
              Turn savers into investors
            </div>
            <div className="content primary row-gap-20">
              <Dash className="bullet-icon" />
              Grow wealth - within your means
            </div>
            <div className="content primary row-gap-20">
              <Dash className="bullet-icon" />
              Protect families when it matters most
            </div>
            <div className="content primary row-gap-20">
              <Dash className="bullet-icon" />
              Support recovery through serious illness
            </div>
            <div className="content primary row-gap-20">
              <Dash className="bullet-icon" />
              Maintain your lifestyle if income stops
            </div>
            <div className="content primary row-gap-20">
              <Dash className="bullet-icon" />
              Secure better mortgage outcomes
            </div>
            <div className="content primary row-gap-20">
              <Dash className="bullet-icon" />
              Help first-time buyers get on the ladder
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurMission;
